<template>
  <div class="recipe-order big">
    <el-table v-loading="tableLoading"
              :data="recipeData"
              :span-method="objectSpanMethod"
              border
              style="width: 100%; margin-top: 20px"
              :cell-style="cellStyle">
      <el-table-column v-for="item in tableHeader"
                       :key="item.prop"
                       :prop="item.prop"
                       :label="item.label"
                       :width="item.width"
                       :align="item.align">
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     size="medium"
                     @click="editorBtn(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分账编辑 -->
    <el-dialog :title="dialogTitle"
               :visible.sync="recipeDialog"
               width="600px"
               style="text-align:left;"
               :close-on-click-modal="true"
               append-to-body
               class="big">
      <div class="recipe-dialog billSet-dialog">
        <el-form :model="recipeForm"
                 :rules="rules"
                 ref="recipeFormRef"
                 label-width="180px"
                 class="demo-recipeForm">

          <el-form-item label="是否开启分账"
                        prop="is_open">
            <el-switch v-model="recipeForm.is_open"
                       :active-value="1"
                       :inactive-value="0"></el-switch>
          </el-form-item>

          <el-form-item label="诊后管理费"
                        prop="consult_drug_price">
            <el-select style="width: 330px;"
                       v-model="recipeForm.consult_drug_price"
                       placeholder="请选择">
              <el-option v-for="item in configList"
                         :key="item.key"
                         :label="item.name"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="诊金"
                        prop="consulting_gold">
            <el-select style="width: 330px;"
                       v-model="recipeForm.consulting_gold"
                       placeholder="请选择">
              <el-option v-for="item in configList"
                         :key="item.key"
                         :label="item.name"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="快递费"
                        prop="freight_price">
            <el-select style="width: 330px;"
                       v-model="recipeForm.freight_price"
                       placeholder="请选择">
              <el-option v-for="item in configList"
                         :key="item.key"
                         :label="item.name"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="加工费"
                        prop="drug_machining_price">
            <el-select style="width: 330px;"
                       v-model="recipeForm.drug_machining_price"
                       placeholder="请选择">
              <el-option v-for="item in configList"
                         :key="item.key"
                         :label="item.name"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="药品成本金额"
                        prop="drug_cost_price">
            <el-select style="width: 330px;"
                       v-model="recipeForm.drug_cost_price"
                       placeholder="请选择">
              <el-option v-for="item in configList"
                         :key="item.key"
                         :label="item.name"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="药品加价金额"
                        prop="drug_difference_price">
            <el-select style="width: 330px;"
                       v-model="recipeForm.drug_difference_price"
                       placeholder="请选择">
              <el-option v-for="item in configList"
                         :key="item.key"
                         :label="item.name"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="save('recipeFormRef')"
                   size="small"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('723') : false"
                   type="primary"
                   plain>保 存</el-button>
        <el-button @click="close"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('723') : false"
                   size="small"
                   plain>关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from '../../../api/system';
export default {
  props: {
    configList: {
      type: Array,
      require: true,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      recipeDialog: false,
      dialogTitle: '',
      recipeForm: {
        is_open: 0,
        consult_drug_price: '',
        consulting_gold: '',
        freight_price: '',
        drug_machining_price: '',
        drug_cost_price: '',
        drug_difference_price: ''
      },
      rules: {
        is_open: [{ required: true, message: '请选择', trigger: 'change' }],
        consult_drug_price: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        consulting_gold: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        freight_price: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        drug_machining_price: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        drug_cost_price: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        drug_difference_price: [
          { required: true, message: '请选择', trigger: 'change' }
        ]
      },
      tableHeader: [
        {
          label: '药房名称',
          prop: 'hospital_name',
          width: 'auto',
          algin: 'center'
        },
        {
          label: '剂型名称',
          prop: 'drug_type_name',
          width: 'auto',
          algin: 'center'
        }
      ],
      recipeData: [],
      spanArr: [],
      position: 0
    };
  },
  // watch: {
  //   configList: {
  //     handler: function (n, o) {
  //       console.log('11', this.configList);
  //     },
  //     deep: true
  //   }
  // },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      if (this.module_id_array[0] && !this.module_id_array.includes('722')) {
        return;
      }
      this.spanArr = [];
      this.position = 0;
      this.tableLoading = true;
      system.getChinaumsHospitalDrugType().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.recipeData = data.list;
          this.rowspan();
          this.tableLoading = false;
        }
      });
    },
    rowspan() {
      for (let i = 0; i < this.recipeData.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.recipeData[i].hospital_name ===
            this.recipeData[i - 1].hospital_name
          ) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = i;
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    cellStyle(row, column) {
      if (row.columnIndex === 0) {
        return 'background-color: transparent';
      }
    },
    editorBtn(row) {
      for (let key in row) {
        if (!row[key] && row[key] !== 0) {
          row[key] = '';
        }
      }
      this.dialogTitle = `${row.hospital_name}-${row.drug_type_name}`;
      this.recipeDialog = true;
      this.$nextTick(() => {
        this.$refs['recipeFormRef'].resetFields();
        this.recipeForm = Object.assign(this.recipeForm, row);
      });
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          system.setChinaumsHospitalDrugType(this.recipeForm).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success('保存成功');
              this.recipeDialog = false;
              this.getList();
            }
          });
        } else {
          return false;
        }
      });
    },
    close() {
      this.recipeDialog = false;
    }
  }
};
</script>

<style lang="scss" >
</style>